import { Stack, Divider } from '@mui/material';
import { DataCard } from './DataCard';
import { CardTypes, AiAssistantConversation } from './types';
import { WrapperWithHeader } from './WrapperWithHeader';
import { colors } from '@sweep-io/sweep-design';

const BORDER_COLOR = colors.grey[120];

export const AiAssistantPerformance = ({
  tableData,
  startDate,
  endDate,
  isCollapsed,
}: {
  tableData: AiAssistantConversation[];
  startDate: string;
  endDate: string;
  isCollapsed?: boolean;
}) => {
  if (isCollapsed) {
    return (
      <WrapperWithHeader title="Performance" sx={{ height: 'auto', gap: 0, pt: 1 }}>
        <Stack
          direction="row"
          sx={{
            mt: 1,
            border: `1px solid ${BORDER_COLOR}`,
            borderRadius: '4px',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottom: 0,
          }}
        >
          {DataCard(CardTypes.TotalSupportRequests, tableData, startDate, endDate, isCollapsed)}
          <Divider
            orientation="vertical"
            flexItem
            sx={{ borderColor: BORDER_COLOR, mt: 1.7, height: '62%' }}
          />
          {DataCard(CardTypes.ResolutionRate, tableData, startDate, endDate, isCollapsed)}
        </Stack>
        <Stack
          direction="row"
          sx={{
            border: `1px solid ${BORDER_COLOR}`,
            borderRadius: '4px',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderTop: 0,
          }}
        >
          {DataCard(CardTypes.AdminSupportRequests, tableData, startDate, endDate, isCollapsed)}
          <Divider
            orientation="vertical"
            sx={{ borderColor: BORDER_COLOR, mt: 1.7, height: '62%' }}
          />
          {DataCard(CardTypes.InProgress, tableData, startDate, endDate, isCollapsed)}
        </Stack>
      </WrapperWithHeader>
    );
  }

  return (
    <WrapperWithHeader title="Performance" sx={{ height: 'auto' }}>
      <Stack direction="row" sx={{ border: `1px solid ${BORDER_COLOR}`, borderRadius: '4px' }}>
        {DataCard(CardTypes.TotalSupportRequests, tableData, startDate, endDate)}
        <Divider orientation="vertical" flexItem sx={{ borderColor: BORDER_COLOR }} />
        {DataCard(CardTypes.ResolutionRate, tableData, startDate, endDate)}
        <Divider orientation="vertical" flexItem sx={{ borderColor: BORDER_COLOR }} />
        {DataCard(CardTypes.AdminSupportRequests, tableData, startDate, endDate)}
        <Divider orientation="vertical" flexItem sx={{ borderColor: BORDER_COLOR }} />
        {DataCard(CardTypes.InProgress, tableData, startDate, endDate)}
      </Stack>
    </WrapperWithHeader>
  );
};
